import React, { Component } from 'react';

import SidebarComponent from '../components/SidebarComponent';
import NavbarComponent from '../components/NavbarComponent';
import HeaderComponent from '../components/HeaderComponent';
import TableInvoiceComponent from '../components/TableInvoiceComponent';
import FacturasTabs from '../components/FacturasTabs';
import { validateSession } from  '../utils/functions';
import { navigateTo } from '../utils/navigation';
import "react-datepicker/dist/react-datepicker.css";

class InvoicesPage extends Component {

	constructor(){
        super();
        this.state = {
            loading: false,
            checked: false,
            dateSelected: new Date(),
            role: 0,
            products: {},
        }
	}

	async componentDidMount() {
        let role = await validateSession()
        this.setState({ checked: true, role:  role});
    }

    addInvoice = () => {
        navigateTo('/addInvoice');
    }

	render() {
        if (!this.state.checked) {
            return (<div></div>);
        } else {
            return (  
                <div className="container-fluid">
                    <div className="row">
                        <SidebarComponent itemSelected={17} role={this.state.role}/>
                        <main className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                            <NavbarComponent role={this.state.role} />
                            <div className="main-content-container container-fluid px-4 mb-4" style={{paddingBottom: '80px'}}>
                                <HeaderComponent title="Compras" subtitle="Facturas"/>
                                <FacturasTabs active="/invoices" />
                                <TableInvoiceComponent role={this.state.role}/>
                            </div>
                        </main>
                    </div>
                    {this.state.role == 1 || this.state.role == 2 ? 
                        <div onClick={() => this.addInvoice()} class="color-switcher-toggle animated pulse infinite">
                            <i class="material-icons">add</i>
                        </div> : <div></div>
                    }
                </div>
            );
        }
    }
}

export default InvoicesPage;
